exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PowerStatus__statusOn___jiCu6 {\n  font-size: 12px;\n  font-weight: 700;\n  color: #03d8a9;\n}\n\n.PowerStatus__statusOn___jiCu6::before {\n  display: inline-block;\n  content: \"\";\n  margin-right: 10px;\n  height: 8px;\n  width: 8px;\n  background-color: #03d8a9;\n  border-radius: 50%;\n}\n\n.PowerStatus__statusOff___j9Dbo {\n  font-size: 12px;\n  font-weight: 700;\n  color: #9da9b6;\n}\n\n.PowerStatus__statusOff___j9Dbo::before {\n  display: inline-block;\n  content: \"\";\n  margin-right: 10px;\n  height: 8px;\n  width: 8px;\n  background-color: #9da9b6;\n  border-radius: 50%;\n}\n", ""]);

// exports
exports.locals = {
	"statusOn": "PowerStatus__statusOn___jiCu6",
	"statusOff": "PowerStatus__statusOff___j9Dbo"
};